import { defineStore } from 'pinia'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'
import { ref } from 'vue'

export interface Location {
  id: number;
  city: {
    id: number;
    city_name: string;
  } | null;
  country: {
    id: number;
    country_name: string;
  } | null;
  location_type: string | null;
  region: string | null;
  us_state: string | null;
  location_name: string;
}

// Group interface (for both countries and regions)
export interface LocationGroup {
  id: number;
  name: string;
  type: 'country' | 'region';
  region?: string;  // Only present for region groups
  locations: Location[];
}

// Main response interface
export interface GroupedLocationsResponse {
  groups: LocationGroup[];
}

export const useJobLocationsStore = defineStore('jobLocations', () => {
  const jobLocations = ref<GroupedLocationsResponse>({ groups: [] })
  const isLoading = ref(false)
  const error = ref<string | null>(null)
  
  const fetchJobLocations = async (search: string = '', page: number = 1) => {
    isLoading.value = true
    try {
      const response = await api.get(API_ROUTES.GET_JOB_LOCATIONS, {
        params: { search, page }
      })
      jobLocations.value = response.data
    } catch (err) {
      console.error('Error fetching job locations:', err)
      error.value = 'Failed to fetch job locations'
    } finally {
      isLoading.value = false
    }
  }

  return {
    jobLocations,
    isLoading,
    error,
    fetchJobLocations
  }
})
